import type { IconProps } from './types';
import './icons.css';

export default function Attach({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon-attach ${className || ''}`}
      fill="none"
    >
      <path
        stroke="currentColor"
        d="M13.283 9 6.11 16.172a2.829 2.829 0 0 0 4 4l9.008-9.008a4.773 4.773 0 1 0-6.75-6.75l-9.347 9.347"
      />
    </svg>
  );
}
